import { keyBy } from "lodash"

const semesters = [
    { id: "1", label: 'תחילת שנה"ל', name: "תחילת שנה", range: [{ start: '09-01', end: '12-31' }] },
    { id: "2", label: 'אמצע שנה"ל', name: "אמצע שנה", range: [{ start: '01-01', end: '04-30' }] },
    { id: "3", label: 'סוף שנה"ל', name: "סוף שנה", range: [{ start: '05-01', end: '08-31' }] },
]

const semesterKeys = keyBy(semesters, 'id')

export { semesterKeys }
export default semesters